<div class="trainings-container">
  <!-- Header with search and filters -->
  <div class="header-section">
    <div class="search-filters-row">
      <!-- Search bar -->
      <div class="search-section">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Buscar treinamentos</mat-label>
          <input 
            matInput 
            placeholder="Digite o nome do curso, solução ou descrição"
            [(ngModel)]="filterValue"
            (input)="applySearch($any($event.target).value)">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- Filters -->
      <div class="filters-section">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Tipo de Treinamento</mat-label>
          <mat-select [(value)]="selectedTypeFilter" (selectionChange)="applyFilters()">
            <mat-option value="">Todos os tipos</mat-option>
            <mat-option *ngFor="let type of trainingTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Tipo do Sistema</mat-label>
          <mat-select [(value)]="selectedSystemTypeFilter" (selectionChange)="applyFilters()">
            <mat-option value="">Todos os sistemas</mat-option>
            <mat-option *ngFor="let type of systemTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button 
          mat-icon-button 
          matTooltip="Limpar filtros"
          (click)="clearFilters()"
          class="clear-filters-btn">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Action buttons -->
      <div class="action-buttons">
        <button 
          mat-icon-button 
          matTooltip="Alternar visualização"
          (click)="toggleViewMode()"
          class="view-toggle-btn">
          <mat-icon>{{ viewMode === 'grid' ? 'view_list' : 'view_module' }}</mat-icon>
        </button>

        <button 
          *ngIf="hasAdd"
          mat-fab 
          color="primary"
          matTooltip="Adicionar novo treinamento"
          (click)="onNew()"
          class="add-btn">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>

    <!-- Results info -->
    <div class="results-info">
      <span class="results-count">
        {{ length }} {{ length === 1 ? 'treinamento encontrado' : 'treinamentos encontrados' }}
      </span>
    </div>
  </div>

  <!-- Content area -->
  <div class="content-area" [ngClass]="'view-' + viewMode">
    <!-- No data message -->
    <div *ngIf="!filteredData || filteredData.length === 0" class="no-data-message">
      <mat-icon>school</mat-icon>
      <h3>Nenhum treinamento encontrado</h3>
      <p>Tente ajustar os filtros</p>
    </div>

    <!-- Grid view -->
    <div *ngIf="viewMode === 'grid' && filteredData && filteredData.length > 0" class="trainings-grid">
      <div 
        *ngFor="let training of filteredData" 
        class="training-card"
        [ngClass]="{ 'inactive': lockProperty && !training[lockProperty] }">
        
        <!-- Card header with image -->
        <div class="card-header">
          <div class="course-image-container">
            <img 
              [src]="getImageUrl(training.image)" 
              [alt]="''"
              class="course-image"
              >
            
            <!-- Play overlay for video content -->
            <div 
              *ngIf="showPlayButton && training.fileAttachment" 
              class="play-overlay"
              (click)="onPlay(training)">
              <mat-icon>play_circle_filled</mat-icon>
            </div>

            <!-- Download progress overlay -->
            <div 
              *ngIf="isDownloading(training.id)" 
              class="download-overlay">
              <mat-progress-spinner 
                [value]="getProgressPercentage(training.id)"
                mode="determinate"
                diameter="40">
              </mat-progress-spinner>
              <button 
                mat-icon-button 
                (click)="onCancelDownload(training)"
                class="cancel-download-btn">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          <!-- Type and system badges -->
          <div class="badges-container">
            <span class="type-badge">{{ training.type }}</span>
            <span class="system-badge">{{ training.systemName }}</span>
          </div>
        </div>

        <!-- Card content -->
        <div class="card-content">
          <h3 class="course-title" (click)="onShow(training)">
            {{ training.trainingName }}
          </h3>

          <div class="course-meta">
            <span class="training-type">
              <mat-icon>label</mat-icon>
              {{ training.fileType }}
            </span>
            <span class="system-version">
              <mat-icon>update</mat-icon>
              v{{ training.systemVersion }}
            </span>
          </div>

          <p class="course-description">
            {{ training.fileDescription }}
          </p>

          <div class="course-details">
            <div class="detail-item">
              <mat-icon>schedule</mat-icon>
              <span>{{ formatDate(training.createdAt) }}</span>
            </div>
            <div class="detail-item">
              <mat-icon>{{ getFileIcon(training.fileAttachment?.split('.').pop()) }}</mat-icon>
              <span>{{ formatFileSize(training.fileSize) }}</span>
            </div>
          </div>
        </div>

        <!-- Card actions -->
        <div class="card-actions">

            <button 
              mat-icon-button 
              matTooltip="Visualizar"
              (click)="onShow(training)">
              <mat-icon>visibility</mat-icon>
            </button>

            <button 
              *ngIf="isEditableShow"
              mat-icon-button 
              matTooltip="Editar"
              [disabled]="!isEditableEnabled"
              (click)="onEdit(training)">
              <mat-icon>edit</mat-icon>
            </button>

            <button 
              *ngIf="showDescription"
              mat-icon-button 
              matTooltip="Descrição"
              (click)="onDescription(training)">
              <mat-icon>info</mat-icon>
            </button>
        
            <button 
              *ngIf="showDownload && training.fileAttachment"
              mat-icon-button 
              matTooltip="Download"
              [disabled]="isDownloading(training.id)"
              (click)="onDownload(training)">
              <mat-icon>download</mat-icon>
            </button>

            <button 
              *ngIf="showLock && isLockActionShow"
              mat-icon-button 
              [matTooltip]="lockProperty && training[lockProperty] ? 'Desbloquear' : 'Bloquear'"
              [disabled]="!isLockActionEnabled"
              (click)="onLock(training)">
              <mat-icon>{{ lockProperty && training[lockProperty] ? 'lock' : 'lock_open' }}</mat-icon>
            </button>

            <button 
              *ngIf="isDeletableShow"
              mat-icon-button 
              matTooltip="Excluir"
              [disabled]="!isDeletableEnabled"
              (click)="onDelete(training)"
              class="delete-btn">
              <mat-icon>delete</mat-icon>
            </button>

        </div>
      </div>
    </div>

    <!-- List view -->
    <div *ngIf="viewMode === 'list' && filteredData && filteredData.length > 0" class="trainings-list">
              <div 
          *ngFor="let training of filteredData" 
          class="training-list-item"
          [ngClass]="{ 'inactive': lockProperty && !training[lockProperty] }">
        
        <div class="list-item-image">
          <img 
            [src]="getImageUrl(training.image)" 
            [alt]="''"
            class="list-course-image">
        </div>

        <div class="list-item-content">
          <h4 class="list-course-title" (click)="onShow(training)">
            {{ training.trainingName }}
          </h4>
          
          <div class="list-meta">
            <span class="list-system">{{ training.system }}</span>
            <span class="list-type">{{ training.fileType }}</span>
            <span class="list-version">v{{ training.systemVersion }}</span>
          </div>

          <p class="list-description">{{ training.fileDescription }}</p>
        </div>

        <div class="list-item-actions">
          <button mat-icon-button (click)="onShow(training)">
            <mat-icon>visibility</mat-icon>
          </button>
          <button *ngIf="isEditableShow" mat-icon-button (click)="onEdit(training)">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="showDownload" mat-icon-button (click)="onDownload(training)">
            <mat-icon>download</mat-icon>
          </button>
          <button *ngIf="isDeletableShow" mat-icon-button (click)="onDelete(training)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container" *ngIf="shouldShowPagination()">
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="getPageSizeOptions()"
      [pageIndex]="currentPage"
      showFirstLastButtons
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</div> 